import {FundingRoundIO} from "ui-io/company-io"
import fetchApi from "../fetch-api";
import * as t from 'io-ts'

export const getFundingRoundsById = (props: {companyID:string|undefined}) => {
	return {
		queryKey: ["FUNDING_ROUNDS_BY_ID", props.companyID],
		queryFn: () =>
			fetchApi({
				service:"admin-service",
				headers:{method: 'GET'},
				pathname: `/funding-rounds?companyID=${ props.companyID}`,
				codec: t.array(FundingRoundIO)
			})
	};
};
